<script>
    import Label from './Label.svelte?1733898724933';
    import Field from './Field.svelte?1733898724933';
    import { createEventDispatcher, onMount } from 'svelte';

    export let categories = [];
    export let open = false;
    export let name = '';
    export let value = undefined;

    const dispatch = createEventDispatcher();
    let showMore = false;
    let displayedLines = 0;
    let real_values = {};
    let details = {};
    let timer;
    let allChecked = true;
    let initialized = false;

    $: update_real_values(value);
    $: if (!open) {
        update();
    }

    function handleAllChange(event) {
        allChecked = event.target.checked;
        Object.keys(real_values).forEach((key) => {
            real_values[key] = false;
        });
        //update();
    }

    function handleCheckboxChange(event, entryValue) {
        allChecked = false;
        real_values[entryValue] = event.target.checked;
    }

    function update() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            const data = {};
            let set = false;
            Object.keys(real_values).forEach((key) => {
                if (real_values[key]) {
                    set = true;
                    data[key] = true;
                }
            });
            if (!set) {
                value = undefined;
                details = {};
                dispatch('details', details);
                return;
            }
            value = data;
            details = {};
            Object.keys(real_values).forEach((valueId) => {
                let matchedDetail = null;

                // Hauptkategorien durchsuchen
                const matchingCategory = categories.find((cat) => cat.value.toString() === valueId);
                if (matchingCategory) {
                    matchedDetail = {
                        key: matchingCategory.key,
                        value: matchingCategory.value,
                        skus: [], // oder verwenden Sie matchingCategory.skus, wenn es existiert
                    };
                } else {
                    // Wenn nicht gefunden, dann in den children suchen
                    for (let category of categories) {
                        if (category.children) {
                            const matchingSubCategory = category.children.find(
                                (subCat) => subCat.value.toString() === valueId
                            );
                            if (matchingSubCategory) {
                                matchedDetail = {
                                    key: matchingSubCategory.key,
                                    value: matchingSubCategory.value,
                                    skus: [], // oder verwenden Sie matchingSubCategory.skus, wenn es existiert
                                };
                                break;
                            }
                        }
                    }
                }

                if (matchedDetail) {
                    details[valueId] = matchedDetail;
                }
            });
            dispatch('details', { key: name, details });
        }, 100);
    }

    function update_real_values(value) {
        if (value == undefined) {
            real_values = {};
            return;
        }
        // when the facet gets initialized allow setting the value from outside, afterwards its forbidden
        if(!initialized) {
            initialized = true;
            real_values = value;
        }
    }

    function shouldDisplayNext() {
        if (displayedLines < 5) {
            displayedLines += 1;
            return true;
        }
        return false;
    }
</script>

<Field headline="Unterkategorien" bind:open>
    <div class="input m-input m-input--checkbox">
        <Label id="childs_select_all" text="Alle">
            <input type="checkbox" id="childs_select_all" bind:checked={allChecked} on:change={handleAllChange} />
            <span class="m-input__trigger ri-check-line" />
        </Label>
    </div>
    {#each categories as entry}
        {#if showMore || shouldDisplayNext()}
            <div class="input m-input m-input--checkbox">
                <Label text={entry.key} id="{name}_{entry.value}">
                    <input
                        type="checkbox"
                        id="{name}_{entry.value}"
                        value={entry.value}
                        name="category_ids"
                        bind:checked={real_values[entry.value]}
                        on:change={(e) => {
                            handleCheckboxChange(e, entry.value);
                        }}
                    />
                    <span class="m-input__trigger ri-check-line" />
                </Label>
                {#if entry.children}
                    {#each entry.children as subCategory}
                        {#if showMore || shouldDisplayNext()}
                            <div class="input m-input m-input--checkbox" style="margin-left: 32px;">
                                <Label text={subCategory.key} id="{name}_{subCategory.value}">
                                    <input
                                        type="checkbox"
                                        id="{name}_{subCategory.value}"
                                        value={subCategory.value}
                                        name="category_ids"
                                        bind:checked={real_values[subCategory.value]}
                                        on:change={(e) => {
                                            handleCheckboxChange(e, subCategory.value);
                                        }}
                                    />
                                    <span class="m-input__trigger ri-check-line" />
                                </Label>
                            </div>
                        {/if}
                    {/each}
                {/if}
            </div>
        {/if}
    {/each}

    {#if categories.length + categories.reduce((acc, cat) => acc + (cat.children ? cat.children.length : 0), 0) > 5}
        <div class="button">
            <button
                class="more_loader btn btn--ghost btn--small"
                on:click={() => ((showMore = !showMore), (displayedLines = 0))}
            >
                {showMore ? window.__('facet.show_less') : window.__('facet.load_more')}
            </button>
        </div>
    {/if}
</Field>


<style>
    .input {
        flex-wrap: wrap;
        width: 100%;
    }
    .more_loader {
        text-align: center;
    }
    .button {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    :global(label) {
        font-size: 0.875rem !important;
    }
</style>